!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("react-hammerjs"), require("inline-style-prefixer"), require("lodash.differenceby"), require("react-motion")) : "function" == typeof define && define.amd ? define(["react", "react-hammerjs", "inline-style-prefixer", "lodash.differenceby", "react-motion"], t) : "object" == typeof exports ? exports.ReactSwipeableTabs = t(require("react"), require("react-hammerjs"), require("inline-style-prefixer"), require("lodash.differenceby"), require("react-motion")) : e.ReactSwipeableTabs = t(e.React, e.Hammerjs, e.InlineStylePrefixer, e.LodashDifferenceBy, e.ReactMotion);
}(this, function (e, t, n, r, i) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var i = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return e[r].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.p = "build/", t(0);
  }([function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function i(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
      return Array.from(e);
    }
    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      },
      c = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      f = n(1),
      l = r(f),
      p = n(22),
      d = r(p),
      h = n(20),
      y = r(h),
      m = n(25),
      v = n(24),
      b = (r(v), n(10)),
      g = r(b),
      _ = n(11),
      T = r(_),
      w = n(3),
      P = r(w),
      O = n(9),
      I = r(O),
      R = function (e) {
        function t(e) {
          o(this, t);
          var n = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          E.call(n), n.currentFrame = {
            translateX: 0
          };
          var r = n.formatItems(n.props.items);
          return n.animator = new I.default(r), n.updateAnimatorFromProps(n.props), n.state = {
            items: r,
            activeItemIndex: n.props.activeItemIndex,
            translateX: 0,
            borderWidth: 0,
            borderTranslateX: 0
          }, n;
        }
        return s(t, e), c(t, [{
          key: "componentWillReceiveProps",
          value: function value(e) {
            if (this.updateAnimatorFromProps(e), e.activeItemIndex !== this.props.activeItemIndex && this.setState({
              activeItemIndex: e.activeItemIndex
            }), !this.checkEqualItems(e.items, this.props.items)) {
              var t = this.formatItems(e.items);
              this.animator.setItems(t), this.setState({
                items: t
              });
            }
          }
        }, {
          key: "componentWillUpdate",
          value: function value(e, t) {
            (t.activeItemIndex !== this.state.activeItemIndex || t.requestCenterActiveItem || t.items !== this.state.items) && this.setState(u({}, this.getCenterItemState(t.items, t.activeItemIndex), {
              requestCenterActiveItem: !1
            }));
          }
        }, {
          key: "renderList",
          value: function value(e, t, n) {
            var r = l.default.createElement(g.default, {
              borderThickness: this.props.borderThickness,
              borderColor: this.props.borderColor,
              borderTranslateX: t,
              borderWidth: n
            });
            return l.default.createElement("div", {
              style: this.getTranslateStyle(e)
            }, "top" === this.props.borderPosition ? r : null, l.default.createElement(T.default, {
              items: this.state.items,
              containerWidth: this.animator.getContainerWidth(),
              alignCenter: this.props.alignCenter,
              itemStyle: this.props.itemStyle,
              fitItems: this.props.fitItems,
              onItemClick: this.onItemClick,
              onItemChange: this.onItemChange,
              noFirstLeftPadding: this.props.noFirstLeftPadding,
              noLastRightPadding: this.props.noLastRightPadding,
              itemClassName: this.props.itemClassName,
              activeStyle: this.props.activeStyle,
              isItemActive: this.isItemActive
            }), "bottom" === this.props.borderPosition ? r : null);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this;
            return l.default.createElement(y.default, {
              bounds: !0,
              onResize: this.onResize
            }, function (t) {
              var n = t.measureRef;
              return l.default.createElement("div", {
                ref: n
              }, l.default.createElement(d.default, {
                onPanStart: e.onPanStart,
                onPanEnd: e.onPanEnd,
                onPan: e.onPan
              }, l.default.createElement("div", {
                ref: e.refContainerWidthDetector,
                style: e.getContainerStyle()
              }, l.default.createElement(m.Motion, {
                defaultStyle: e.getInitialFrame(),
                style: e.calculateNextFrame()
              }, function (t) {
                var n = t.translateX,
                  r = t.borderTranslateX,
                  i = t.borderWidth;
                return e.renderList(n, r, i);
              }))));
            });
          }
        }]), t;
      }(l.default.Component);
    R.propTypes = {
      items: l.default.PropTypes.arrayOf(l.default.PropTypes.element).isRequired,
      onItemClick: l.default.PropTypes.func.isRequired,
      activeItemIndex: l.default.PropTypes.number,
      itemClassName: l.default.PropTypes.string,
      itemStyle: l.default.PropTypes.object,
      activeStyle: l.default.PropTypes.object,
      alignCenter: l.default.PropTypes.bool,
      fitItems: l.default.PropTypes.bool,
      noFirstLeftPadding: l.default.PropTypes.bool,
      noLastRightPadding: l.default.PropTypes.bool,
      borderPosition: l.default.PropTypes.oneOf(["top", "bottom"]),
      borderColor: l.default.PropTypes.string,
      borderThickness: l.default.PropTypes.number,
      borderWidthRatio: l.default.PropTypes.number,
      safeMargin: l.default.PropTypes.number,
      initialTranslation: l.default.PropTypes.number,
      stiffness: l.default.PropTypes.number,
      damping: l.default.PropTypes.number,
      resistanceCoeffiecent: l.default.PropTypes.number,
      gravityAccelarion: l.default.PropTypes.number,
      dragCoefficient: l.default.PropTypes.number
    }, R.defaultProps = {
      resistanceCoeffiecent: .5,
      gravityAccelarion: 9.8,
      dragCoefficient: .04,
      stiffness: 170,
      damping: 26,
      activeItemIndex: 0,
      safeMargin: 100,
      borderPosition: "bottom",
      borderColor: "#333",
      borderThickness: 2,
      borderWidthRatio: 1,
      alignCenter: !0,
      activeStyle: {},
      noFirstLeftPadding: !1,
      noLastRightPadding: !1,
      fitItems: !1,
      itemStyle: {},
      initialTranslation: 0
    };
    var E = function E() {
      var e = this;
      this.onResize = function () {
        e.setState({
          requestCenterActiveItem: !0
        });
      }, this.formatItems = function (e) {
        return e.map(function (e) {
          return {
            element: e,
            width: 0,
            left: 0
          };
        });
      }, this.checkEqualItems = function (e, t) {
        return e === t;
      }, this.onPanStart = function (t) {
        e.animator.startDrag();
      }, this.onPanEnd = function (t) {
        e.animator.endDrag(), e.setState({
          translateX: e.animator.calculateSwipeReleaseTranslateX(t.deltaX)
        });
      }, this.onPan = function (t) {
        e.setState({
          translateX: e.animator.calculateSwipeTranslateX(t.deltaX)
        });
      }, this.getTranslateStyle = function (t) {
        return e.animator.setCurrentTranslateX(t), {
          transform: "translate(" + t + "px, 0)"
        };
      }, this.getContainerStyle = function () {
        return (0, P.default)({
          position: "relative",
          width: "100%",
          overflow: "hidden",
          textAlign: "center"
        });
      }, this.getCenterItemState = function (t, n) {
        var r = t[n];
        return r || (r = t[0], e.onItemClick(r, n)), {
          borderWidth: e.animator.getBorderWidth(r),
          translateX: e.animator.calculateItemTranslateX(r),
          borderTranslateX: e.animator.calculateBorderTranslateX(r)
        };
      }, this.updateAnimatorFromProps = function (t) {
        e.animator.setBorderWidthRatio(t.borderWidthRatio), e.animator.setSafeMargin(t.safeMargin), e.animator.setInitialTranslation(t.initialTranslation), e.animator.setNoFirstLeftPadding(t.noFirstLeftPadding), e.animator.setNoLastRightPadding(t.noLastRightPadding), e.animator.setResistanceCoeffiecent(t.resistanceCoeffiecent);
      }, this.getInitialFrame = function () {
        return {
          translateX: e.state.translateX,
          borderWidth: e.state.borderWidth,
          borderTranslateX: e.state.borderTranslateX
        };
      }, this.calculateNextFrame = function () {
        var t = {
          stiffness: e.props.stiffness,
          damping: e.props.damping
        };
        return {
          translateX: (0, m.spring)(e.state.translateX, t),
          borderTranslateX: (0, m.spring)(e.state.borderTranslateX, t),
          borderWidth: (0, m.spring)(e.state.borderWidth, t)
        };
      }, this.refContainerWidthDetector = function (t) {
        t && e.animator.setContainerWidth(t.clientWidth);
      }, this.onItemClick = function (t) {
        var n = e.getItemIndex(t);
        e.setState({
          requestToCenterItem: !0,
          activeItemIndex: n
        }), e.props.onItemClick(t, n);
      }, this.onItemChange = function (t, n, r) {
        var o = e.state.items.indexOf(t),
          a = [].concat(i(e.state.items.slice(0, o)), [u({}, t, {
            width: n,
            left: r
          })], i(e.state.items.slice(o + 1)));
        e.animator.setItems(a), e.setState({
          items: a
        });
      }, this.isItemActive = function (t) {
        return e.state.activeItemIndex === e.getItemIndex(t);
      }, this.getItemIndex = function (t) {
        return e.state.items.indexOf(t);
      };
    };
    t.default = R;
  }, function (t, n) {
    t.exports = e;
  }, function (e, t) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }
    function r() {
      throw new Error("clearTimeout has not been defined");
    }
    function i(e) {
      if (f === setTimeout) return setTimeout(e, 0);
      if ((f === n || !f) && setTimeout) return f = setTimeout, setTimeout(e, 0);
      try {
        return f(e, 0);
      } catch (t) {
        try {
          return f.call(null, e, 0);
        } catch (t) {
          return f.call(this, e, 0);
        }
      }
    }
    function o(e) {
      if (l === clearTimeout) return clearTimeout(e);
      if ((l === r || !l) && clearTimeout) return l = clearTimeout, clearTimeout(e);
      try {
        return l(e);
      } catch (t) {
        try {
          return l.call(null, e);
        } catch (t) {
          return l.call(this, e);
        }
      }
    }
    function a() {
      y && d && (y = !1, d.length ? h = d.concat(h) : m = -1, h.length && s());
    }
    function s() {
      if (!y) {
        var e = i(a);
        y = !0;
        for (var t = h.length; t;) {
          for (d = h, h = []; ++m < t;) d && d[m].run();
          m = -1, t = h.length;
        }
        d = null, y = !1, o(e);
      }
    }
    function u(e, t) {
      this.fun = e, this.array = t;
    }
    function c() {}
    var f,
      l,
      p = e.exports = {};
    !function () {
      try {
        f = "function" == typeof setTimeout ? setTimeout : n;
      } catch (e) {
        f = n;
      }
      try {
        l = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (e) {
        l = r;
      }
    }();
    var d,
      h = [],
      y = !1,
      m = -1;
    p.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
      h.push(new u(e, t)), 1 !== h.length || y || i(s);
    }, u.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = c, p.addListener = c, p.once = c, p.off = c, p.removeListener = c, p.removeAllListeners = c, p.emit = c, p.prependListener = c, p.prependOnceListener = c, p.listeners = function (e) {
      return [];
    }, p.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, p.cwd = function () {
      return "/";
    }, p.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, p.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(23),
      o = r(i),
      a = new o.default();
    t.default = function (e) {
      return a.prefix(e);
    };
  }, function (e, t) {
    "use strict";

    function n(e) {
      return function () {
        return e;
      };
    }
    var r = function r() {};
    r.thatReturns = n, r.thatReturnsFalse = n(!1), r.thatReturnsTrue = n(!0), r.thatReturnsNull = n(null), r.thatReturnsThis = function () {
      return this;
    }, r.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = r;
  }, function (e, t, n) {
    (function (t) {
      "use strict";

      function n(e, t, n, i, o, a, s, u) {
        if (r(t), !e) {
          var c;
          if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var f = [n, i, o, a, s, u],
              l = 0;
            c = new Error(t.replace(/%s/g, function () {
              return f[l++];
            })), c.name = "Invariant Violation";
          }
          throw c.framesToPop = 1, c;
        }
      }
      var r = function r(e) {};
      "production" !== t.env.NODE_ENV && (r = function r(e) {
        if (void 0 === e) throw new Error("invariant requires an error message argument");
      }), e.exports = n;
    }).call(t, n(2));
  }, function (e, t) {
    "use strict";

    var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    e.exports = n;
  }, function (e, t, n) {
    (function (t) {
      "use strict";

      var r = n(4),
        i = r;
      "production" !== t.env.NODE_ENV && !function () {
        var e = function e(_e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          var i = 0,
            o = "Warning: " + _e.replace(/%s/g, function () {
              return n[i++];
            });
          "undefined" != typeof console && console.error(o);
          try {
            throw new Error(o);
          } catch (e) {}
        };
        i = function i(t, n) {
          if (void 0 === n) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
          if (0 !== n.indexOf("Failed Composite propType: ") && !t) {
            for (var r = arguments.length, i = Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++) i[o - 2] = arguments[o];
            e.apply(void 0, [n].concat(i));
          }
        };
      }(), e.exports = i;
    }).call(t, n(2));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function i(e, t) {
      var n = {};
      for (var r in e) t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
      return n;
    }
    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    function u(e) {
      return function (t) {
        var n, r;
        return r = n = function (n) {
          function r() {
            var t, n, i, s;
            o(this, r);
            for (var u = arguments.length, c = Array(u), f = 0; f < u; f++) c[f] = arguments[f];
            return n = i = a(this, (t = r.__proto__ || Object.getPrototypeOf(r)).call.apply(t, [this].concat(c))), i.state = {
              contentRect: {
                entry: {},
                client: {},
                offset: {},
                scroll: {},
                bounds: {},
                margin: {}
              }
            }, i.measure = function (t) {
              var n = (0, g.default)(i._node, e || (0, v.default)(i.props));
              t && (n.entry = t[0].contentRect), i.setState({
                contentRect: n
              }), "function" == typeof i.props.onResize && i.props.onResize(n);
            }, i._handleRef = function (e) {
              i._resizeObserver && (e ? i._resizeObserver.observe(e) : i._resizeObserver.disconnect(i._node)), i._node = e, "function" == typeof i.props.innerRef && i.props.innerRef(e);
            }, s = n, a(i, s);
          }
          return s(r, n), f(r, [{
            key: "componentWillMount",
            value: function value() {
              this._resizeObserver = new y.default(this.measure);
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                n = (e.innerRef, e.onResize, i(e, ["innerRef", "onResize"]));
              return (0, l.createElement)(t, c({}, n, {
                measureRef: this._handleRef,
                measure: this.measure,
                contentRect: this.state.contentRect
              }));
            }
          }]), r;
        }(l.Component), n.propTypes = {
          client: d.default.bool,
          offset: d.default.bool,
          scroll: d.default.bool,
          bounds: d.default.bool,
          margin: d.default.bool,
          innerRef: d.default.func,
          onResize: d.default.func,
          children: d.default.func
        }, r;
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var c = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      },
      f = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      l = n(1),
      p = (r(l), n(16)),
      d = r(p),
      h = n(21),
      y = r(h),
      m = n(19),
      v = r(m),
      b = n(18),
      g = r(b);
    t.default = u, e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      i = function i() {
        return new Date().getTime();
      },
      o = function () {
        function e(t) {
          n(this, e), this.setItems(t), this.containerWidth = 100;
        }
        return r(e, [{
          key: "setItems",
          value: function value(e) {
            this.items = e;
          }
        }, {
          key: "setContainerWidth",
          value: function value(e) {
            this.containerWidth = e;
          }
        }, {
          key: "getContainerWidth",
          value: function value() {
            return this.containerWidth;
          }
        }, {
          key: "setBorderWidthRatio",
          value: function value(e) {
            this.borderWidthRatio = e;
          }
        }, {
          key: "setSafeMargin",
          value: function value(e) {
            this.safeMargin = e;
          }
        }, {
          key: "setInitialTranslation",
          value: function value(e) {
            this.initialTranslation = e;
          }
        }, {
          key: "setNoFirstLeftPadding",
          value: function value(e) {
            this.noFirstLeftPadding = e;
          }
        }, {
          key: "setNoLastRightPadding",
          value: function value(e) {
            this.noLastRightPadding = e;
          }
        }, {
          key: "setResistanceCoeffiecent",
          value: function value(e) {
            this.resistanceCoeffiecent = e;
          }
        }, {
          key: "setCurrentTranslateX",
          value: function value(e) {
            this.currentTranslateX = e;
          }
        }, {
          key: "startDrag",
          value: function value() {
            this.startDragMillis = i(), this.startTranslateX = this.currentTranslateX;
          }
        }, {
          key: "endDrag",
          value: function value() {
            this.endDragMillis = i();
          }
        }, {
          key: "getListWidth",
          value: function value() {
            var e = 0;
            return this.items.forEach(function (t) {
              return e += t.width;
            }), e;
          }
        }, {
          key: "getFirstItemLeft",
          value: function value() {
            return this.items[0].left;
          }
        }, {
          key: "getItemLeft",
          value: function value(e) {
            return this.isFirstItem(e) ? 0 : e.left - this.getFirstItemLeft();
          }
        }, {
          key: "getItemWidth",
          value: function value(e) {
            return e.width;
          }
        }, {
          key: "getBorderWidth",
          value: function value(e) {
            return this.getItemWidth(e) * this.borderWidthRatio;
          }
        }, {
          key: "isFirstItem",
          value: function value(e) {
            return this.items[0] === e;
          }
        }, {
          key: "isLastItem",
          value: function value(e) {
            return this.items.indexOf(e) === this.items.length - 1;
          }
        }, {
          key: "isFarLeft",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return e > (t ? this.safeMargin : 0);
          }
        }, {
          key: "isFarRight",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = t ? this.safeMargin : 0;
            return e * -1 + this.containerWidth > this.getListWidth() + n;
          }
        }, {
          key: "isListSmallerContainer",
          value: function value() {
            return this.getListWidth() < this.containerWidth;
          }
        }, {
          key: "getFarLeftTranslation",
          value: function value(e) {
            return this.initialTranslation + 0 + (e ? this.safeMargin : 0);
          }
        }, {
          key: "getFarRightTranslation",
          value: function value(e) {
            return this.initialTranslation - this.getListWidth() + this.containerWidth - (e ? this.safeMargin : 0);
          }
        }, {
          key: "checkAndGetTranslateX",
          value: function value(e, t) {
            return this.isFarLeft(e, t) ? this.getFarLeftTranslation(t) : this.isFarRight(e, t) ? this.getFarRightTranslation(t) : e;
          }
        }, {
          key: "calculateSwipeNextDistance",
          value: function value(e) {
            var t = Math.abs(e),
              n = this.endDragMillis - this.startDragMillis,
              r = 9.8,
              i = .05,
              o = 2 * t / Math.pow(n, 2),
              a = Math.abs(o - r * i) * -1,
              s = 2 * t / n,
              u = Math.pow(s, 2) / (2 * a) * -1 * (1 / this.resistanceCoeffiecent);
            return e > 0 ? u : -1 * u;
          }
        }, {
          key: "calculateItemTranslateX",
          value: function value(e) {
            if (this.isListSmallerContainer()) return this.currentTranslateX;
            var t = this.getItemLeft(e),
              n = this.containerWidth / 2,
              r = this.getItemWidth(e) / 2,
              i = this.initialTranslation - t + n - r;
            return this.checkAndGetTranslateX(i, !1);
          }
        }, {
          key: "calculateSwipeReleaseTranslateX",
          value: function value(e) {
            if (this.isListSmallerContainer()) return this.currentTranslateX;
            var t = this.calculateSwipeNextDistance(e);
            return this.checkAndGetTranslateX(t + this.currentTranslateX, !1);
          }
        }, {
          key: "calculateBorderTranslateX",
          value: function value(e) {
            var t = this.getItemWidth(e),
              n = this.getItemLeft(e),
              r = this.getBorderWidth(e);
            return this.noFirstLeftPadding && this.isFirstItem(e) ? n : this.noLastRightPadding && this.isLastItem(e) ? n + t - r : n + t / 2 - r / 2;
          }
        }, {
          key: "calculateSwipeTranslateX",
          value: function value(e) {
            return this.isListSmallerContainer() ? this.currentTranslateX : this.checkAndGetTranslateX(e + this.startTranslateX, !0);
          }
        }]), e;
      }();
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      u = n(1),
      c = r(u),
      f = n(3),
      l = r(f),
      p = function (e) {
        function t() {
          return i(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return a(t, e), s(t, [{
          key: "getBorderStyle",
          value: function value() {
            return (0, l.default)({
              height: this.props.borderThickness,
              background: this.props.borderColor,
              width: this.props.borderWidth,
              transform: "translate(" + this.props.borderTranslateX + "px, 0)"
            });
          }
        }, {
          key: "render",
          value: function value() {
            return c.default.createElement("div", {
              style: this.getBorderStyle()
            });
          }
        }]), t;
      }(c.default.Component);
    p.propTypes = {
      borderThickness: c.default.PropTypes.number,
      borderColor: c.default.PropTypes.string,
      borderWidth: c.default.PropTypes.number,
      borderTranslateX: c.default.PropTypes.number
    }, t.default = p;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      u = n(1),
      c = r(u),
      f = n(3),
      l = r(f),
      p = n(12),
      d = r(p),
      h = function (e) {
        function t() {
          return i(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return a(t, e), s(t, [{
          key: "isFirstItem",
          value: function value(e) {
            return this.props.items[0] === e;
          }
        }, {
          key: "isLastItem",
          value: function value(e) {
            return this.props.items.indexOf(e) === this.props.items.length - 1;
          }
        }, {
          key: "getListWidth",
          value: function value() {
            var e = 0;
            return this.props.items.forEach(function (t) {
              return e += t.width;
            }), e;
          }
        }, {
          key: "isListSmallerThanWindow",
          value: function value() {
            return this.getListWidth() < this.props.containerWidth;
          }
        }, {
          key: "getListStyle",
          value: function value() {
            return (0, l.default)({
              listStyle: "none",
              display: "flex",
              flexDirection: "row",
              margin: 0,
              padding: 0,
              justifyContent: this.props.alignCenter && this.isListSmallerThanWindow() ? "center" : void 0
            });
          }
        }, {
          key: "renderListItems",
          value: function value() {
            var e = this;
            return this.props.items.map(function (t, n) {
              return c.default.createElement(d.default, {
                key: n,
                item: t,
                style: e.props.itemStyle,
                fitInContainer: e.props.fitItems,
                onClick: e.props.onItemClick,
                className: e.props.itemClassName,
                noLeftPadding: e.props.noFirstLeftPadding && e.isFirstItem(t),
                noRightPadding: e.props.noLastRightPadding && e.isLastItem(t),
                onChange: e.props.onItemChange,
                isItemActive: e.props.isItemActive,
                activeStyle: e.props.activeStyle
              });
            });
          }
        }, {
          key: "render",
          value: function value() {
            return c.default.createElement("ul", {
              style: this.getListStyle()
            }, this.renderListItems());
          }
        }]), t;
      }(c.default.Component);
    h.propTypes = {
      items: c.default.PropTypes.arrayOf(c.default.PropTypes.shape({
        element: c.default.PropTypes.element.isRequired,
        width: c.default.PropTypes.number.isRequired,
        left: c.default.PropTypes.number.isRequired
      })).isRequired,
      alignCenter: c.default.PropTypes.bool,
      onItemChange: c.default.PropTypes.func.isRequired,
      itemStyle: c.default.PropTypes.object,
      fitItems: c.default.PropTypes.bool,
      onItemClick: c.default.PropTypes.func.isRequired,
      noFirstLeftPadding: c.default.PropTypes.bool,
      noLastRightPadding: c.default.PropTypes.bool,
      itemClassName: c.default.PropTypes.string,
      containerWidth: c.default.PropTypes.number,
      activeStyle: c.default.PropTypes.object.isRequired,
      isItemActive: c.default.PropTypes.func.isRequired
    }, t.default = h;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      },
      u = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      c = n(1),
      f = r(c),
      l = n(3),
      p = r(l),
      d = function (e) {
        function t() {
          var e, n, r, a;
          i(this, t);
          for (var s = arguments.length, u = Array(s), c = 0; c < s; c++) u[c] = arguments[c];
          return n = r = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(u))), r.checkChanged = function (e, t) {
            return r.props.item.width !== e || r.props.item.left !== t;
          }, r.refListItemDetector = function (e) {
            e && r.checkChanged(e.clientWidth, e.offsetLeft) && r.props.onChange(r.props.item, e.clientWidth, e.offsetLeft);
          }, a = n, o(r, a);
        }
        return a(t, e), u(t, [{
          key: "getItemStyle",
          value: function value() {
            var e = s({}, this.props.style);
            this.props.fitInContainer ? (e.flexShrink = 1, e.flexGrow = 1) : e.flexShrink = 0, this.props.noLeftPadding && (e.paddingLeft = 0, e.justifyContent = "flex-start"), this.props.noRightPadding && (e.paddingRight = 0, e.justifyContent = "flex-end"), this.props.isItemActive(this.props.item) && (e = s({}, e, this.props.activeStyle));
            var t = {
              padding: "20px",
              cursor: "pointer",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            };
            return (0, p.default)(s({}, t, e));
          }
        }, {
          key: "render",
          value: function value() {
            var e = this;
            return f.default.createElement("li", {
              ref: this.refListItemDetector.bind(this),
              onClick: function onClick() {
                return e.props.onClick(e.props.item);
              },
              style: this.getItemStyle(),
              className: this.props.className
            }, this.props.item.element);
          }
        }]), t;
      }(f.default.Component);
    d.propTypes = {
      item: f.default.PropTypes.shape({
        element: f.default.PropTypes.element.isRequired,
        width: f.default.PropTypes.number.isRequired,
        left: f.default.PropTypes.number.isRequired
      }).isRequired,
      onChange: f.default.PropTypes.func.isRequired,
      style: f.default.PropTypes.object,
      fitInContainer: f.default.PropTypes.bool,
      onClick: f.default.PropTypes.func.isRequired,
      noLeftPadding: f.default.PropTypes.bool,
      noRightPadding: f.default.PropTypes.bool,
      className: f.default.PropTypes.string,
      isItemActive: f.default.PropTypes.func.isRequired,
      activeStyle: f.default.PropTypes.object.isRequired
    }, t.default = d;
  }, function (e, t, n) {
    (function (t) {
      "use strict";

      function r(e, n, r, u, c) {
        if ("production" !== t.env.NODE_ENV) for (var f in e) if (e.hasOwnProperty(f)) {
          var l;
          try {
            i("function" == typeof e[f], "%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.", u || "React class", r, f), l = e[f](n, f, u, r, null, a);
          } catch (e) {
            l = e;
          }
          if (o(!l || l instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", u || "React class", r, f, typeof l), l instanceof Error && !(l.message in s)) {
            s[l.message] = !0;
            var p = c ? c() : "";
            o(!1, "Failed %s type: %s%s", r, l.message, null != p ? p : "");
          }
        }
      }
      if ("production" !== t.env.NODE_ENV) var i = n(5),
        o = n(7),
        a = n(6),
        s = {};
      e.exports = r;
    }).call(t, n(2));
  }, function (e, t, n) {
    "use strict";

    var r = n(4),
      i = n(5),
      o = n(6);
    e.exports = function () {
      function e(e, t, n, r, a, s) {
        s !== o && i(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    (function (t) {
      "use strict";

      var r = n(4),
        i = n(5),
        o = n(7),
        a = n(6),
        s = n(13);
      e.exports = function (e, n) {
        function u(e) {
          var t = e && (x && e[x] || e[k]);
          if ("function" == typeof t) return t;
        }
        function c(e, t) {
          return e === t ? 0 !== e || 1 / e === 1 / t : e !== e && t !== t;
        }
        function f(e) {
          this.message = e, this.stack = "";
        }
        function l(e) {
          function r(r, c, l, p, d, h, y) {
            if (p = p || C, h = h || l, y !== a) if (n) i(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if ("production" !== t.env.NODE_ENV && "undefined" != typeof console) {
              var m = p + ":" + l;
              !s[m] && u < 3 && (o(!1, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", h, p), s[m] = !0, u++);
            }
            return null == c[l] ? r ? new f(null === c[l] ? "The " + d + " `" + h + "` is marked as required " + ("in `" + p + "`, but its value is `null`.") : "The " + d + " `" + h + "` is marked as required in " + ("`" + p + "`, but its value is `undefined`.")) : null : e(c, l, p, d, h);
          }
          if ("production" !== t.env.NODE_ENV) var s = {},
            u = 0;
          var c = r.bind(null, !1);
          return c.isRequired = r.bind(null, !0), c;
        }
        function p(e) {
          function t(t, n, r, i, o, a) {
            var s = t[n],
              u = O(s);
            if (u !== e) {
              var c = I(s);
              return new f("Invalid " + i + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."));
            }
            return null;
          }
          return l(t);
        }
        function d() {
          return l(r.thatReturnsNull);
        }
        function h(e) {
          function t(t, n, r, i, o) {
            if ("function" != typeof e) return new f("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
            var s = t[n];
            if (!Array.isArray(s)) {
              var u = O(s);
              return new f("Invalid " + i + " `" + o + "` of type " + ("`" + u + "` supplied to `" + r + "`, expected an array."));
            }
            for (var c = 0; c < s.length; c++) {
              var l = e(s, c, r, i, o + "[" + c + "]", a);
              if (l instanceof Error) return l;
            }
            return null;
          }
          return l(t);
        }
        function y() {
          function t(t, n, r, i, o) {
            var a = t[n];
            if (!e(a)) {
              var s = O(a);
              return new f("Invalid " + i + " `" + o + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
            }
            return null;
          }
          return l(t);
        }
        function m(e) {
          function t(t, n, r, i, o) {
            if (!(t[n] instanceof e)) {
              var a = e.name || C,
                s = E(t[n]);
              return new f("Invalid " + i + " `" + o + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + a + "`."));
            }
            return null;
          }
          return l(t);
        }
        function v(e) {
          function n(t, n, r, i, o) {
            for (var a = t[n], s = 0; s < e.length; s++) if (c(a, e[s])) return null;
            var u = JSON.stringify(e);
            return new f("Invalid " + i + " `" + o + "` of value `" + a + "` " + ("supplied to `" + r + "`, expected one of " + u + "."));
          }
          return Array.isArray(e) ? l(n) : ("production" !== t.env.NODE_ENV ? o(!1, "Invalid argument supplied to oneOf, expected an instance of array.") : void 0, r.thatReturnsNull);
        }
        function b(e) {
          function t(t, n, r, i, o) {
            if ("function" != typeof e) return new f("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
            var s = t[n],
              u = O(s);
            if ("object" !== u) return new f("Invalid " + i + " `" + o + "` of type " + ("`" + u + "` supplied to `" + r + "`, expected an object."));
            for (var c in s) if (s.hasOwnProperty(c)) {
              var l = e(s, c, r, i, o + "." + c, a);
              if (l instanceof Error) return l;
            }
            return null;
          }
          return l(t);
        }
        function g(e) {
          function n(t, n, r, i, o) {
            for (var s = 0; s < e.length; s++) {
              var u = e[s];
              if (null == u(t, n, r, i, o, a)) return null;
            }
            return new f("Invalid " + i + " `" + o + "` supplied to " + ("`" + r + "`."));
          }
          if (!Array.isArray(e)) return "production" !== t.env.NODE_ENV ? o(!1, "Invalid argument supplied to oneOfType, expected an instance of array.") : void 0, r.thatReturnsNull;
          for (var i = 0; i < e.length; i++) {
            var s = e[i];
            if ("function" != typeof s) return o(!1, "Invalid argument supplid to oneOfType. Expected an array of check functions, but received %s at index %s.", R(s), i), r.thatReturnsNull;
          }
          return l(n);
        }
        function _() {
          function e(e, t, n, r, i) {
            return w(e[t]) ? null : new f("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
          }
          return l(e);
        }
        function T(e) {
          function t(t, n, r, i, o) {
            var s = t[n],
              u = O(s);
            if ("object" !== u) return new f("Invalid " + i + " `" + o + "` of type `" + u + "` " + ("supplied to `" + r + "`, expected `object`."));
            for (var c in e) {
              var l = e[c];
              if (l) {
                var p = l(s, c, r, i, o + "." + c, a);
                if (p) return p;
              }
            }
            return null;
          }
          return l(t);
        }
        function w(t) {
          switch (typeof t) {
            case "number":
            case "string":
            case "undefined":
              return !0;
            case "boolean":
              return !t;
            case "object":
              if (Array.isArray(t)) return t.every(w);
              if (null === t || e(t)) return !0;
              var n = u(t);
              if (!n) return !1;
              var r,
                i = n.call(t);
              if (n !== t.entries) {
                for (; !(r = i.next()).done;) if (!w(r.value)) return !1;
              } else for (; !(r = i.next()).done;) {
                var o = r.value;
                if (o && !w(o[1])) return !1;
              }
              return !0;
            default:
              return !1;
          }
        }
        function P(e, t) {
          return "symbol" === e || "Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol;
        }
        function O(e) {
          var t = typeof e;
          return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : P(t, e) ? "symbol" : t;
        }
        function I(e) {
          if ("undefined" == typeof e || null === e) return "" + e;
          var t = O(e);
          if ("object" === t) {
            if (e instanceof Date) return "date";
            if (e instanceof RegExp) return "regexp";
          }
          return t;
        }
        function R(e) {
          var t = I(e);
          switch (t) {
            case "array":
            case "object":
              return "an " + t;
            case "boolean":
            case "date":
            case "regexp":
              return "a " + t;
            default:
              return t;
          }
        }
        function E(e) {
          return e.constructor && e.constructor.name ? e.constructor.name : C;
        }
        var x = "function" == typeof Symbol && Symbol.iterator,
          k = "@@iterator",
          C = "<<anonymous>>",
          j = {
            array: p("array"),
            bool: p("boolean"),
            func: p("function"),
            number: p("number"),
            object: p("object"),
            string: p("string"),
            symbol: p("symbol"),
            any: d(),
            arrayOf: h,
            element: y(),
            instanceOf: m,
            node: _(),
            objectOf: b,
            oneOf: v,
            oneOfType: g,
            shape: T
          };
        return f.prototype = Error.prototype, j.checkPropTypes = s, j.PropTypes = j, j;
      };
    }).call(t, n(2));
  }, function (e, t, n) {
    (function (t) {
      if ("production" !== t.env.NODE_ENV) {
        var r = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
          i = function i(e) {
            return "object" == typeof e && null !== e && e.$$typeof === r;
          },
          o = !0;
        e.exports = n(15)(i, o);
      } else e.exports = n(14)();
    }).call(t, n(2));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function i(e) {
      var t = e.measure,
        n = e.measureRef,
        r = e.contentRect,
        i = e.children;
      return i({
        measure: t,
        measureRef: n,
        contentRect: r
      });
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(1),
      a = (r(o), n(8)),
      s = r(a);
    t.default = (0, s.default)()(i), e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      var n = {};
      if (t.indexOf("client") > -1 && (n.client = {
        top: e.clientTop,
        left: e.clientLeft,
        width: e.clientWidth,
        height: e.clientHeight
      }), t.indexOf("offset") > -1 && (n.offset = {
        top: e.offsetTop,
        left: e.offsetLeft,
        width: e.offsetWidth,
        height: e.offsetHeight
      }), t.indexOf("scroll") > -1 && (n.scroll = {
        top: e.scrollTop,
        left: e.scrollLeft,
        width: e.scrollWidth,
        height: e.scrollHeight
      }), t.indexOf("bounds") > -1) {
        var r = e.getBoundingClientRect();
        n.bounds = {
          top: r.top,
          right: r.right,
          bottom: r.bottom,
          left: r.left,
          width: r.width,
          height: r.height
        };
      }
      if (t.indexOf("margin") > -1) {
        var i = getComputedStyle(e);
        n.margin = {
          top: parseInt(i.marginTop),
          right: parseInt(i.marginRight),
          bottom: parseInt(i.marginBottom),
          left: parseInt(i.marginLeft)
        };
      }
      return n;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n, e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function n(e) {
      var t = [];
      return r.forEach(function (n) {
        e[n] && t.push(n);
      }), t;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    var r = ["client", "offset", "scroll", "bounds", "margin"];
    e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.withContentRect = t.default = void 0;
    var i = n(17),
      o = r(i),
      a = n(8),
      s = r(a);
    t.default = o.default, t.withContentRect = s.default;
  }, function (e, t, n) {
    !function (t, n) {
      e.exports = n();
    }(this, function () {
      "use strict";

      function e(e) {
        return parseFloat(e) || 0;
      }
      function t(t) {
        var n = Array.prototype.slice.call(arguments, 1);
        return n.reduce(function (n, r) {
          var i = t["border-" + r + "-width"];
          return n + e(i);
        }, 0);
      }
      function n(t) {
        for (var n = ["top", "right", "bottom", "left"], r = {}, i = 0, o = n; i < o.length; i += 1) {
          var a = o[i],
            s = t["padding-" + a];
          r[a] = e(s);
        }
        return r;
      }
      function r(e) {
        var t = e.getBBox();
        return u(0, 0, t.width, t.height);
      }
      function i(r) {
        var i = r.clientWidth,
          a = r.clientHeight;
        if (!i && !a) return _;
        var s = getComputedStyle(r),
          c = n(s),
          f = c.left + c.right,
          l = c.top + c.bottom,
          p = e(s.width),
          d = e(s.height);
        if ("border-box" === s.boxSizing && (Math.round(p + f) !== i && (p -= t(s, "left", "right") + f), Math.round(d + l) !== a && (d -= t(s, "top", "bottom") + l)), !o(r)) {
          var h = Math.round(p + f) - i,
            y = Math.round(d + l) - a;
          1 !== Math.abs(h) && (p -= h), 1 !== Math.abs(y) && (d -= y);
        }
        return u(c.left, c.top, p, d);
      }
      function o(e) {
        return e === document.documentElement;
      }
      function a(e) {
        return f ? T(e) ? r(e) : i(e) : _;
      }
      function s(e) {
        var t = e.x,
          n = e.y,
          r = e.width,
          i = e.height,
          o = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object,
          a = Object.create(o.prototype);
        return g(a, {
          x: t,
          y: n,
          width: r,
          height: i,
          top: n,
          right: t + r,
          bottom: i + n,
          left: t
        }), a;
      }
      function u(e, t, n, r) {
        return {
          x: e,
          y: t,
          width: n,
          height: r
        };
      }
      var c = function () {
          function e(e, t) {
            var n = -1;
            return e.some(function (e, r) {
              return e[0] === t && (n = r, !0);
            }), n;
          }
          return "undefined" != typeof Map ? Map : function () {
            function t() {
              this.__entries__ = [];
            }
            var n = {
              size: {}
            };
            return n.size.get = function () {
              return this.__entries__.length;
            }, t.prototype.get = function (t) {
              var n = e(this.__entries__, t),
                r = this.__entries__[n];
              return r && r[1];
            }, t.prototype.set = function (t, n) {
              var r = e(this.__entries__, t);
              ~r ? this.__entries__[r][1] = n : this.__entries__.push([t, n]);
            }, t.prototype.delete = function (t) {
              var n = this.__entries__,
                r = e(n, t);
              ~r && n.splice(r, 1);
            }, t.prototype.has = function (t) {
              return !!~e(this.__entries__, t);
            }, t.prototype.clear = function () {
              this.__entries__.splice(0);
            }, t.prototype.forEach = function (e, t) {
              void 0 === t && (t = null);
              for (var n = 0, r = this.__entries__; n < r.length; n += 1) {
                var i = r[n];
                e.call(t, i[1], i[0]);
              }
            }, Object.defineProperties(t.prototype, n), t;
          }();
        }(),
        f = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
        l = function () {
          return "function" == typeof requestAnimationFrame ? requestAnimationFrame : function (e) {
            return setTimeout(function () {
              return e(Date.now());
            }, 1e3 / 60);
          };
        }(),
        p = 2,
        d = function d(e, t) {
          function n() {
            o && (o = !1, e()), a && i();
          }
          function r() {
            l(n);
          }
          function i() {
            var e = Date.now();
            if (o) {
              if (e - s < p) return;
              a = !0;
            } else o = !0, a = !1, setTimeout(r, t);
            s = e;
          }
          var o = !1,
            a = !1,
            s = 0;
          return i;
        },
        h = 20,
        y = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
        m = "undefined" != typeof navigator && /Trident\/.*rv:11/.test(navigator.userAgent),
        v = "undefined" != typeof MutationObserver && !m,
        b = function b() {
          this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = d(this.refresh.bind(this), h);
        };
      b.prototype.addObserver = function (e) {
        ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
      }, b.prototype.removeObserver = function (e) {
        var t = this.observers_,
          n = t.indexOf(e);
        ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_();
      }, b.prototype.refresh = function () {
        var e = this.updateObservers_();
        e && this.refresh();
      }, b.prototype.updateObservers_ = function () {
        var e = this.observers_.filter(function (e) {
          return e.gatherActive(), e.hasActive();
        });
        return e.forEach(function (e) {
          return e.broadcastActive();
        }), e.length > 0;
      }, b.prototype.connect_ = function () {
        f && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), v ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
          attributes: !0,
          childList: !0,
          characterData: !0,
          subtree: !0
        })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
      }, b.prototype.disconnect_ = function () {
        f && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
      }, b.prototype.onTransitionEnd_ = function (e) {
        var t = e.propertyName,
          n = y.some(function (e) {
            return !!~t.indexOf(e);
          });
        n && this.refresh();
      }, b.getInstance = function () {
        return this.instance_ || (this.instance_ = new b()), this.instance_;
      }, b.instance_ = null;
      var g = function g(e, t) {
          for (var n = 0, r = Object.keys(t); n < r.length; n += 1) {
            var i = r[n];
            Object.defineProperty(e, i, {
              value: t[i],
              enumerable: !1,
              writable: !1,
              configurable: !0
            });
          }
          return e;
        },
        _ = u(0, 0, 0, 0),
        T = function () {
          return "undefined" != typeof SVGGraphicsElement ? function (e) {
            return e instanceof SVGGraphicsElement;
          } : function (e) {
            return e instanceof SVGElement && "function" == typeof e.getBBox;
          };
        }(),
        w = function w(e) {
          this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = u(0, 0, 0, 0), this.target = e;
        };
      w.prototype.isActive = function () {
        var e = a(this.target);
        return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
      }, w.prototype.broadcastRect = function () {
        var e = this.contentRect_;
        return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
      };
      var P = function P(e, t) {
          var n = s(t);
          g(this, {
            target: e,
            contentRect: n
          });
        },
        O = function O(e, t, n) {
          if ("function" != typeof e) throw new TypeError("The callback provided as parameter 1 is not a function.");
          this.activeObservations_ = [], this.observations_ = new c(), this.callback_ = e, this.controller_ = t, this.callbackCtx_ = n;
        };
      O.prototype.observe = function (e) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        if ("undefined" != typeof Element && Element instanceof Object) {
          if (!(e instanceof Element)) throw new TypeError('parameter 1 is not of type "Element".');
          var t = this.observations_;
          t.has(e) || (t.set(e, new w(e)), this.controller_.addObserver(this), this.controller_.refresh());
        }
      }, O.prototype.unobserve = function (e) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        if ("undefined" != typeof Element && Element instanceof Object) {
          if (!(e instanceof Element)) throw new TypeError('parameter 1 is not of type "Element".');
          var t = this.observations_;
          t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this));
        }
      }, O.prototype.disconnect = function () {
        this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
      }, O.prototype.gatherActive = function () {
        var e = this;
        this.clearActive(), this.observations_.forEach(function (t) {
          t.isActive() && e.activeObservations_.push(t);
        });
      }, O.prototype.broadcastActive = function () {
        if (this.hasActive()) {
          var e = this.callbackCtx_,
            t = this.activeObservations_.map(function (e) {
              return new P(e.target, e.broadcastRect());
            });
          this.callback_.call(e, t, e), this.clearActive();
        }
      }, O.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
      }, O.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
      };
      var I = "undefined" != typeof WeakMap ? new WeakMap() : new c(),
        R = function R(e) {
          if (!(this instanceof R)) throw new TypeError("Cannot call a class as a function");
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
          var t = b.getInstance(),
            n = new O(e, t, this);
          I.set(this, n);
        };
      ["observe", "unobserve", "disconnect"].forEach(function (e) {
        R.prototype[e] = function () {
          return (t = I.get(this))[e].apply(t, arguments);
          var t;
        };
      });
      var E = function () {
        return "undefined" != typeof ResizeObserver ? ResizeObserver : R;
      }();
      return E;
    });
  }, function (e, n) {
    e.exports = t;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = i;
  }]);
});